import ActionTypes from './ActionTypes';
import Dispatcher from './Dispatcher';

export default {
  all(collectionId) {
    Dispatcher.dispatch({
      actionType: ActionTypes.THEME_STORE_ALL,
      collectionId,
    });
  },

  find(collectionId, themeId) {
    Dispatcher.dispatch({
      actionType: ActionTypes.THEME_STORE_FIND,
      collectionId,
      themeId,
    });
  },

  complete(collectionId, themeId) {
    Dispatcher.dispatch({
      actionType: ActionTypes.THEME_STORE_COMPLETE,
      collectionId,
      themeId,
    });
  },

  chapterEnter(chapterId, themeId) {
    Dispatcher.dispatch({
      actionType: ActionTypes.THEME_STORE_CHAPTER_ENTER,
      themeId,
      chapterId,
    });
  }
}
